import React from 'react';
import PropTypes from 'prop-types';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Popover from 'react-bootstrap/lib/Popover';

import * as styles from './styles.css';
import './styles.scss';

export default function InfoToolTip({ title, children, placement, icon = 'fa fa-info-circle fa-fw text-primary', customCssClass }) {
  return (
    <OverlayTrigger
      placement={placement}
      overlay={
        <Popover
          id="overload-right"
          title={title}
          className={styles.tooltip}
        >
          {children}
        </Popover>
      }
    >
      <i className={customCssClass ? ("fa fa-info-circle fa-fw text-primary "+customCssClass) : icon} />
    </OverlayTrigger>
  );
}

InfoToolTip.defaultProps = {
  placement: 'right',
  icon: 'fa fa-info-circle fa-fw text-primary',
};

InfoToolTip.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  placement: PropTypes.oneOf(['left', 'top', 'right', 'bottom']),
  icon: PropTypes.string,
};

